
import { SubCategoryComponent } from './sub-category/sub-category.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './signin/signin.component';
import { ProductsComponent } from './products/products.component';
import { ProductdetailsComponent } from './productdetails/productdetails.component';
import { RegisterComponent } from './register/register.component';
import { OtpverifyComponent } from './otpverify/otpverify.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { NotificationComponent } from './notification/notification.component';
import { ProductlistComponent } from './productlist/productlist.component';
import { OrderComponent } from './order/order.component';
import { PaymentComponent } from './payment/payment.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { WalletComponent } from './wallet/wallet.component';
import { SearchComponent } from './search/search.component';
import { AboutComponent } from './about/about.component';
import { SupportComponent } from './support/support.component';
import { ProductdetailsvariComponent } from './productdetailsvari/productdetailsvari.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { WelcometwoComponent } from './welcometwo/welcometwo.component';
import { WelcomethreeComponent } from './welcomethree/welcomethree.component';
import { MakupcategoryComponent } from './makupcategory/makupcategory.component';
//import { MakupdetailsComponent } from './makupdetails/makupdetails.component';
import { MakuplistComponent } from './makuplist/makuplist.component';
import { SliderBannerProductComponent } from './slider-banner-product/slider-banner-product.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full'
  },
  {
    path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'list', loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
  
  {
    path: 'productreview', loadChildren: () => import('./productreview/productreview.module').then(m => m.ProductreviewPageModule)
  },
  

  // {
  //   path: 'productdetails', loadChildren: () => import('./productdetails/productdetails.module').then(m => m.ProductdetailsModule)
  // },
  
  { path: 'signin', component: SigninComponent },
  { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardPageModule' },
  { path: 'products', component: ProductsComponent },
  { path: 'productdetails', loadChildren: './productdetails/productdetails.module#ProductdetailsModule' },
  { path: 'productreview', loadChildren: './productreview/productreview.module#ProductreviewPageModule' },
  { path: 'register', component: RegisterComponent },
  { path: 'otpverify', component: OtpverifyComponent },
  { path: 'thankyou', component: ThankyouComponent },
  { path: 'editprofile', component: EditprofileComponent },
  { path: 'cart', component: CartComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'notifications', component: NotificationComponent },
  { path: 'productlist', component:  ProductlistComponent },
  { path: 'productlist_slider', component:  SliderBannerProductComponent },
  { path: 'order', component: OrderComponent },
  { path: 'payment', component:  PaymentComponent },
  { path: 'wishlist', component:  WishlistComponent },
  { path: 'wallet', component: WalletComponent },
  { path: 'search', component:  SearchComponent },
  { path: 'about', component: AboutComponent },
  { path: 'support', component:  SupportComponent },
  { path: 'productdetailsvri', component:  ProductdetailsvariComponent },
  { path: "welcome",  component: WelcomeComponent},
  { path: "welcometwo",  component: WelcometwoComponent},
  { path: "welcomethree",  component: WelcomethreeComponent},
  { path: "makupcategory",  component: MakupcategoryComponent},
  //{ path: "makupdetails",  component: MakupdetailsComponent},
  { path: "makuplist",  component: MakuplistComponent},
  { path: "subcat",  component: SubCategoryComponent},
  { path: 'filter', loadChildren: './filter/filter.module#FilterPageModule' },
  { path: 'sort', loadChildren: './sort/sort.module#SortPageModule' },
  { path: 'sortproduct', loadChildren: './sortproduct/sortproduct.module#SortproductPageModule' },
  { path: 'filterproduct', loadChildren: './filterproduct/filterproduct.module#FilterproductPageModule' },
  { path: 'paymentmethod', loadChildren: './paymentmethod/paymentmethod.module#PaymentmethodPageModule' },
  { path: 'profile', loadChildren: './profile/profile.module#ProfilePageModule' },
  { path: 'changpws', loadChildren: './changpws/changpws.module#ChangpwsPageModule' },
  { path: 'manageaddress', loadChildren: './manageaddress/manageaddress.module#ManageaddressPageModule' },
  { path: 'addaddress', loadChildren: './addaddress/addaddress.module#AddaddressPageModule' },
  { path: 'editaddress', loadChildren: './editaddress/editaddress.module#EditaddressPageModule' },
  { path: 'privacy-policy', loadChildren: './policy/policy.module#PolicyPageModule' },
  { path: 'terms-conditions', loadChildren: './trams/trams.module#TramsPageModule' },
  { path: 'location', loadChildren: './location/location.module#LocationPageModule' },
  { path: 'makupdetails', loadChildren: './makupdetails/makupdetails.module#MakupdetailsPageModule' },
  { path: 'mybooking', loadChildren: './mybooking/mybooking.module#MybookingPageModule' },
  { path: 'makeupthankyou', loadChildren: './makeupthankyou/makeupthankyou.module#MakeupthankyouPageModule' },
  { path: 'service-booking-address', loadChildren: './service-booking-address/service-booking-address.module#ServiceBookingAddressPageModule' },
  { path: 'service-booking-datetime', loadChildren: './service-booking-datetime/service-booking-datetime.module#ServiceBookingDatetimePageModule' },
  { path: 'searchproduct', loadChildren: './searchproduct/searchproduct.module#SearchproductPageModule' },
 // { path: 'product-review', loadChildren: './product-review/product-review.module#ProductReviewPageModule' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
